import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import Footer from '../Footer';
import Navbar from '../Navbar';
import { fetchSingleBlog } from '../../services/api';

const Blog = () => {
  const { id } = useParams();
  const [blog, setBlog] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const getBlog = async () => {
      try {
        setLoading(true);
        const blogData = await fetchSingleBlog(id);
        setBlog(blogData);
      } catch (err) {
        setError('Failed to load blog post');
      } finally {
        setLoading(false);
      }
    };

    getBlog();
  }, [id]);

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gray-100">
        <div className="animate-spin rounded-full h-12 w-12 border-t-2 border-b-2 border-blue-500"></div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gray-100">
        <div className="text-center">
          <p className="text-red-500 text-xl">{error}</p>
          <button 
            className="mt-4 bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded"
            onClick={() => window.location.reload()}
          >
            Try Again
          </button>
        </div>
      </div>
    );
  }

  if (!blog) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gray-100">
        <h1 className="text-3xl font-bold text-gray-800">Blog not found</h1>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-gray-50">
      <Navbar />

      {/* Blog Header with Thumbnail Background */}
      <div className="relative bg-blue-900 text-white py-20 px-6 text-center">
        {/* Thumbnail Background */}
        <div
          className="absolute inset-0 bg-cover bg-center opacity-20"
          style={{ backgroundImage: `url(${blog.thumbnail})` }}
        />

        {/* Overlay */}
        <div className="absolute inset-0 bg-black opacity-50" />

        {/* Content */}
        <div className="relative z-10 max-w-4xl mx-auto">
          <h1 className="text-4xl md:text-6xl font-bold mb-4">{blog.title}</h1>
          <p className="text-gray-300 text-lg">{blog.date}</p>
        </div>
      </div>

      {/* Blog Content */}
      <div
        className="w-full flex justify-center mx-auto py-12 px-4 sm:px-6 lg:px-8"
        style={{
          background: "linear-gradient(to bottom, rgba(27, 38, 70, 0.95) 0%, rgba(27, 38, 70, 1) 6%, rgba(3, 4, 78, 1) 100%)"
        }}
      >
        <div className="max-w-4xl bg-white bg-opacity-40 rounded-3xl shadow-xl overflow-hidden">
          <div className="p-8">
            
            {/* Content */}
            {blog.fullDescription.map((paragraph, index) => (
              <p key={index} className="mb-6 text-gray-200 text-lg">
                {paragraph}
              </p>
            ))}
          </div>
        </div>
      </div>

      <Footer />
    </div>
  );
};

export default Blog;